export default "__VITE_ASSET__89c658cc__"